import { render, staticRenderFns } from "./RealEstateDamagesDetailModal.vue?vue&type=template&id=0f479866&scoped=true"
import script from "./RealEstateDamagesDetailModal.vue?vue&type=script&lang=ts"
export * from "./RealEstateDamagesDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./RealEstateDamagesDetailModal.vue?vue&type=style&index=0&id=0f479866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f479866",
  null
  
)

export default component.exports